import cmp from './WelcomeHeader'

export default cmp
